import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import Print from 'vue-print-nb'
import './assets/main.css'
import DOMPurify from 'dompurify'
import safeHtmlDirective from './directive/safeHtml'
// 引入Element UI专属过滤mixin
import elInputFilterMixin from './mixin/elInputFilter'
// 引入XSS过滤配置、安全指令

// import VueAxios from 'vue-axios'
Vue.use(Print); //注册
Vue.config.productionTip = false
Vue.prototype.axios = axios;
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.mixin(elInputFilterMixin)
Vue.use(safeHtmlDirective)
Vue.prototype.$richTextXssFilter = (html) => {
  if (!html || typeof html !== 'string') return ''
  return DOMPurify.sanitize(html, {
    // 白名单：必须包含p、br，且放在最前面
    ALLOWED_TAGS: ['p', 'br', 'h1', 'h2', 'h3', 'strong', 'em', 'u', 'span', 'div', 'ul', 'ol', 'li', 'table', 'tr', 'td', 'quote'],
    // 允许p标签的所有合法属性（仅禁止事件属性）
    ALLOWED_ATTR: ['src', 'alt', 'title', 'class', 'style'],
    // 仅禁止事件属性，不要拦截p标签的基础属性
    DISALLOW_ATTR: ['on*', 'href', 'data-*'],
    // 保留HTML结构，禁止转义标签为纯文本
    PRESERVE_WHITESPACE: true,
    // 禁止自动转义HTML实体，确保<p>标签正常渲染
    FORBID_TAGS: ['script', 'iframe', 'embed', 'svg', 'form', 'input', 'button', 'a']
  })
}
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
Vue.directive('has', {
  bind: function (el, binding, vnode) {
    // 获取页面按钮权限
    let btnPermissionsStr = binding.value
    let isExist = false;
    // 获取用户按钮权限
    let btnPermissionsArr = JSON.parse(sessionStorage.getItem("userroles")).permissionValueList;
    if (btnPermissionsArr.indexOf(btnPermissionsStr) > -1) {
      isExist = true;
    }
    if (!isExist) {
      el.style = 'display:none';
    }
  }
});
Vue.directive('debounce', {
  inserted(el, binding) {
    el.addEventListener('click', e => {
      el.classList.add('is-disabled')
      el.disabled = true
      setTimeout(() => {
        el.disabled = false
        el.classList.remove('is-disabled')
      }, 2000)//我这里设置的是2000毫秒也就是2秒
    })
  }
})
router.beforeEach((to, from, next) => {
  const filterXss = (str) => {
    if (typeof str !== 'string') return str
    // 过滤<>&"'\/等危险字符，替换为空
    return str.replace(/[<>&"'\\/]/g, '').trim()
  }
  if (to.query) {
    Object.keys(to.query).forEach(key => {
      to.query[key] = filterXss(to.query[key])
      // 若参数为数字类型，强制校验（如?id=123，非数字直接拦截）
      if (['id', 'uid', 'cid'].includes(key) && !/^\d+$/.test(to.query[key])) {
        next('/') // 跳转到403页面，禁止访问
        return
      }
    })
  }
  if (to.params) {
    Object.keys(to.params).forEach(key => {
      to.params[key] = filterXss(to.params[key])
    })
  }

  if (to.meta.title) {
    document.title = to.meta.title
  }

  if (to.path.toLowerCase() === '/' || to.path == '/teacher/signTeacher' || to.path == '/teacher/teachlogin' || to.path == '/teacher/teacherInfo' || to.path == '/teacher/updateTeacher') {
    next()
  } else {
    if (!sessionStorage.getItem('token')) {
      next({
        path: '/'
      }) //router文件夹下index.js文件里定义了/login对应的映射q
      return
    } else {
      let tabList = sessionStorage.getItem("tabList")
      next()
    }
  }
  //如果本地 存在 token 则 不允许直接跳转到 登录页面
  if (to.path === "/") {
    if (sessionStorage.getItem('token')) {
      next({
        path: from.path
      });
    } else {
      next();
    }
  }
})
